<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        @click="print"
        :disabled="disableInput"
      >
        <v-icon>print</v-icon>
        Print Report
      </v-btn>
    </v-card-actions>

    <div :id="elementId">
      <v-app>
        <v-container fluid>
          <report-header />

          <div v-show="!loading">
            <slot  />
          </div>

          <v-row>
            <v-col class="text-center">
              <v-progress-circular
                v-show="loading"
                indeterminate
                color="primary"
                class="ma-10"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <hr />
              Report generated {{ now | formatDateTime }}
            </v-col>
          </v-row>
        </v-container>
      </v-app>
    </div>
  </v-card>
</template>

<style>
.unset-all {
  all: inherit !important;
}
</style>

<script>
import ReportHeader from './ReportHeader.vue'
export default {
  name: 'Report',

  components: { ReportHeader },

  props: {
    name: {
      type: String,
      default: 'report'
    },
    disableInput: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    now: new Date()
  }),

  computed: {
    elementId () {
      return `report_${this._uid}`
    },

    title () {
      const now = new Date()
      const parts = ['msa', this.name.toLowerCase(), now.toISOString()]
      return parts.join('_')
    }
  },

  methods: {
    async print () {
      await this.$htmlToPaper(this.elementId, {
        windowTitle: this.title
      })
    }
  }
}
</script>
